import apiClient from "./axios"

export const getNotificationEvents = async (params = {}) => {
  const { data } = await apiClient.get("/notification-events", { params })
  return data
}

export const getNotificationEventMeta = async () => {
  const { data } = await apiClient.get("/notification-events/meta")
  return data
}

export const updateNotificationEvent = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/notification-events/${id}`, payload)
  return data
}
